(()=>{
  'use strict';

  const menu=document.querySelector('[data-mbf-mobile-menu]');
  const body=document.body;
  const openers=[...document.querySelectorAll('[data-mbf-menu-open]')];
  const closers=menu?[...menu.querySelectorAll('[data-mbf-menu-close]')]:[];
  const panel=menu?.querySelector('.mobile-menu__panel');
  let lastTrigger=null;
  let closeTimer=null;

  const setLocked=(locked)=>{
    document.documentElement.classList.toggle('mbf-menu-open',locked);
    body?.classList.toggle('mbf-menu-open',locked);
  };

  const syncAria=(open)=>{
    if(!menu)return;
    menu.setAttribute('aria-hidden',open?'false':'true');
    openers.forEach(button=>button.setAttribute('aria-expanded',open?'true':'false'));
  };

  const showMenu=(trigger)=>{
    if(!menu)return;
    if(closeTimer){clearTimeout(closeTimer);closeTimer=null;}
    lastTrigger=trigger||document.activeElement;
    menu.hidden=false;
    requestAnimationFrame(()=>{
      menu.classList.add('is-open');
      syncAria(true);
      setLocked(true);
      requestAnimationFrame(()=>panel?.focus({preventScroll:true}));
    });
  };

  const hideMenu=(restoreFocus=true,immediate=false)=>{
    if(!menu)return;
    if(closeTimer){clearTimeout(closeTimer);closeTimer=null;}
    menu.classList.remove('is-open');
    syncAria(false);
    setLocked(false);
    const finish=()=>{
      menu.hidden=true;
      if(restoreFocus&&lastTrigger&&typeof lastTrigger.focus==='function'){
        try{lastTrigger.focus({preventScroll:true});}catch(_){lastTrigger.focus();}
      }
    };
    if(immediate)finish();
    else closeTimer=setTimeout(finish,180);
  };

  if(menu){
    openers.forEach(button=>button.addEventListener('click',event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      showMenu(button);
    },true));

    closers.forEach(button=>button.addEventListener('click',event=>{
      event.preventDefault();
      event.stopImmediatePropagation();
      hideMenu(true,false);
    },true));

    menu.addEventListener('click',event=>{
      if(event.target===menu){
        event.preventDefault();
        event.stopImmediatePropagation();
        hideMenu(true,false);
      }
    },true);

    document.addEventListener('keydown',event=>{
      if(menu.hidden)return;
      if(event.key==='Escape'){
        event.preventDefault();
        hideMenu(true,false);
        return;
      }
      if(event.key!=='Tab'||!panel)return;
      const focusable=[...panel.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>!el.hidden&&el.offsetParent!==null);
      if(!focusable.length){event.preventDefault();panel.focus();return;}
      const first=focusable[0],last=focusable[focusable.length-1];
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });

    window.addEventListener('resize',()=>{
      if(window.innerWidth>900&&!menu.hidden)hideMenu(false,true);
    });

    syncAria(false);
    setLocked(false);
    menu.hidden=true;
  }

  const serviceHandles=new Set([
    'personal-training',
    'training-plans',
    'peptides',
    'physical-store',
    'about-the-mbf',
    'founder-ceo-mj-paknahad',
    'contact',
    'reviews'
  ]);

  const currentLang=(document.documentElement.lang||'en').toLowerCase().split('-')[0];
  let routeRoot=window.Shopify?.routes?.root||'';
  if(!routeRoot)routeRoot=currentLang==='en'?'/':`/${currentLang}/`;
  if(!routeRoot.endsWith('/'))routeRoot+='/' ;

  const previewParams=()=>{
    const params=new URLSearchParams();
    const here=new URL(window.location.href);
    here.searchParams.forEach((value,key)=>{
      if(key==='preview_theme_id'||key==='_fd'||key==='pb'||key.startsWith('preview_')){
        params.set(key,value);
      }
    });
    return params;
  };

  const canonicalFor=(handle,sourceHref='')=>{
    const url=new URL(`${routeRoot}pages/${handle}`,window.location.origin);
    if(sourceHref){
      try{
        const source=new URL(sourceHref,window.location.href);
        source.searchParams.forEach((value,key)=>url.searchParams.set(key,value));
        url.hash=source.hash;
      }catch(_){}
    }
    previewParams().forEach((value,key)=>{
      if(!url.searchParams.has(key))url.searchParams.set(key,value);
    });
    return url;
  };

  const serviceHandleFrom=(href)=>{
    let url;
    try{url=new URL(href,window.location.href);}catch(_){return '';}
    if(url.origin!==window.location.origin)return '';
    const parts=url.pathname.split('/').filter(Boolean);
    for(let i=parts.length-1;i>=0;i--){
      if(serviceHandles.has(parts[i]))return parts[i];
    }
    return '';
  };

  const normalizeLink=(link)=>{
    if(!link||!link.getAttribute)return;
    const raw=link.getAttribute('href')||'';
    const handle=serviceHandleFrom(raw);
    if(!handle)return;
    const canonical=canonicalFor(handle,raw);
    if(link.href!==canonical.href)link.href=canonical.href;
  };

  const normalizeAll=(root=document)=>{
    root.querySelectorAll?.('a[href]').forEach(normalizeLink);
  };

  normalizeAll();

  document.addEventListener('click',event=>{
    const target=event.target;
    if(!(target instanceof Element))return;
    const link=target.closest('a[href]');
    if(!link)return;
    const handle=serviceHandleFrom(link.getAttribute('href')||'');
    if(!handle)return;
    normalizeLink(link);
    if(menu&&menu.contains(link))hideMenu(false,true);
  },true);

  const observer=new MutationObserver(records=>{
    records.forEach(record=>{
      record.addedNodes.forEach(node=>{
        if(node.nodeType!==1)return;
        if(node.matches?.('a[href]'))normalizeLink(node);
        normalizeAll(node);
      });
    });
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});

  const portalLabels={
    en:{back:'Back',home:'Home'},
    nl:{back:'Terug',home:'Home'},
    de:{back:'Zurück',home:'Startseite'},
    fr:{back:'Retour',home:'Accueil'},
    fa:{back:'بازگشت',home:'خانه'},
    ar:{back:'رجوع',home:'الرئيسية'}
  };

  const portalKind=()=>{
    const parts=window.location.pathname.split('/').filter(Boolean).map(part=>part.toLowerCase());
    return [...parts].reverse().find(part=>part==='vip'||part==='coach')||'';
  };

  const mountPortalEscape=()=>{
    if(!portalKind()||document.querySelector('[data-mbf-portal-escape]'))return;
    const labels=portalLabels[currentLang]||portalLabels.en;
    const homeUrl=new URL(routeRoot,window.location.origin);
    previewParams().forEach((value,key)=>homeUrl.searchParams.set(key,value));

    if(!document.getElementById('mbf-portal-escape-style')){
      const style=document.createElement('style');
      style.id='mbf-portal-escape-style';
      style.textContent=`
        .mbf-portal-escape{position:fixed;inset-inline-start:max(14px,env(safe-area-inset-left));bottom:max(18px,env(safe-area-inset-bottom));z-index:2147483000;display:flex;align-items:center;gap:8px;padding:7px;border:1px solid rgba(255,75,43,.58);border-radius:999px;background:rgba(9,9,10,.93);box-shadow:0 16px 44px rgba(0,0,0,.38);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px)}
        .mbf-portal-escape a,.mbf-portal-escape button{min-height:42px;display:inline-flex;align-items:center;justify-content:center;gap:7px;padding:0 14px;border:0;border-radius:999px;font:800 12px/1 system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;letter-spacing:.02em;text-decoration:none;cursor:pointer;white-space:nowrap}
        .mbf-portal-escape button{background:#1b1b1d;color:#fff}
        .mbf-portal-escape a{background:linear-gradient(135deg,#ff4b2b,#ff702d);color:#fff}
        .mbf-portal-escape button:focus-visible,.mbf-portal-escape a:focus-visible{outline:2px solid #fff;outline-offset:2px}
        @media(min-width:750px){.mbf-portal-escape{bottom:24px}.mbf-portal-escape a,.mbf-portal-escape button{min-height:44px;padding:0 16px}}
      `;
      document.head.appendChild(style);
    }

    const nav=document.createElement('nav');
    nav.className='mbf-portal-escape';
    nav.dataset.mbfPortalEscape='1';
    nav.setAttribute('aria-label','Portal navigation');

    const back=document.createElement('button');
    back.type='button';
    const backIcon=document.createElement('span');
    backIcon.setAttribute('aria-hidden','true');
    backIcon.textContent=document.documentElement.dir==='rtl'?'→':'←';
    const backText=document.createElement('span');
    backText.textContent=labels.back;
    back.append(backIcon,backText);
    back.addEventListener('click',()=>{
      let canReturn=false;
      try{
        if(document.referrer){
          const referrer=new URL(document.referrer);
          canReturn=referrer.origin===window.location.origin&&referrer.href!==window.location.href;
        }
      }catch(_){}
      if(canReturn)window.history.back();
      else window.location.assign(homeUrl.href);
    });

    const home=document.createElement('a');
    home.href=homeUrl.href;
    const homeIcon=document.createElement('span');
    homeIcon.setAttribute('aria-hidden','true');
    homeIcon.textContent='⌂';
    const homeText=document.createElement('span');
    homeText.textContent=labels.home;
    home.append(homeIcon,homeText);

    nav.append(back,home);
    document.body.appendChild(nav);
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',mountPortalEscape,{once:true});
  }else{
    mountPortalEscape();
  }

  if(body?.classList.contains('template-404')){
    const parts=window.location.pathname.split('/').filter(Boolean);
    const handle=[...parts].reverse().find(part=>serviceHandles.has(part))||'';
    const current=new URL(window.location.href);
    if(handle&&!current.searchParams.has('mbf_route_retry')){
      const target=canonicalFor(handle,current.href);
      target.searchParams.set('mbf_route_retry','1');
      target.searchParams.set('mbf_route_ts',String(Date.now()));
      window.location.replace(target.href);
    }
  }
})();